var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.11,
    height: 40.037,
    viewBox: "0 0 38.11 40.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-add-svgrepo-com",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6880",
    "data-name": "Path 6880",
    d: "M23.908,9,24.8,8.11a3.789,3.789,0,1,1,5.358,5.358l-.893.893M23.908,9a6.036,6.036,0,0,0,1.786,3.572,6.037,6.037,0,0,0,3.572,1.786M23.908,9l-8.21,8.21a13.173,13.173,0,0,0-1.073,1.141A6.328,6.328,0,0,0,13.9,19.52a13.152,13.152,0,0,0-.54,1.47l-.8,2.389-.258.773m16.956-9.79-8.21,8.21a13.173,13.173,0,0,1-1.141,1.073,6.328,6.328,0,0,1-1.167.721,13.153,13.153,0,0,1-1.47.54l-2.389.8-.773.258m0,0-.773.258a1.022,1.022,0,0,1-1.292-1.292l.258-.773m1.808,1.808L12.31,24.151",
    transform: "translate(5.342 2.634)",
    fill: "none",
    stroke: "#5607f6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6881",
    "data-name": "Path 6881",
    d: "M8,13h4.817",
    transform: "translate(1.634 8.195)",
    fill: "none",
    stroke: "#5607f6",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6882",
    "data-name": "Path 6882",
    d: "M8,9H20.525",
    transform: "translate(1.634 4.488)",
    fill: "none",
    stroke: "#5607f6",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6883",
    "data-name": "Path 6883",
    d: "M8,17h2.89",
    transform: "translate(1.634 11.903)",
    fill: "none",
    stroke: "#5607f6",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6884",
    "data-name": "Path 6884",
    d: "M35.426,4.257C33.169,2,29.535,2,22.269,2H18.415C11.148,2,7.515,2,5.257,4.257S3,10.148,3,17.415v7.707c0,7.267,0,10.9,2.257,13.157s5.891,2.258,13.157,2.258h3.854c7.267,0,10.9,0,13.157-2.258,1.817-1.817,2.172-4.526,2.241-9.3",
    transform: "translate(-3 -2)",
    fill: "none",
    stroke: "#5607f6",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.9cf9bd66e74b5bd615a50d717aebbe92.svg";
export { ForwardRef as ReactComponent };